import { createSlice } from "@reduxjs/toolkit";

const adminSlice = createSlice({
  name: "admin",
  initialState: {
    admins: [],
    loading: false,
    error: null,
    total: 0,
    page: 0,
    limit: 5,
    permissions: {},
    permissionsLoading: false,
    permissionsError: null,
    updateSuccess: false
  },
  reducers: {
    // Fetch Admins
    fetchAdminsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchAdminsSuccess: (state, action) => {
      state.loading = false;
      state.admins = action.payload.data || [];
      state.total = action.payload.total || 0;
      state.page = action.payload.page || 1;
      state.limit = action.payload.limit || 5;
    },
    fetchAdminsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Create Admin
    createAdminRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    createAdminSuccess: (state) => {
      state.loading = false;
    },
    createAdminFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Edit Admin
    editAdminRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    editAdminSuccess: (state) => {
      state.loading = false;
    },
    editAdminFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Delete Admin
    deleteAdminRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    deleteAdminSuccess: (state, action) => {
      state.loading = false;
      state.admins = state.admins.filter(
        (admin) => admin._id !== action.payload
      );
    },
    deleteAdminFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    //  Admin Status
    toggleAdminStatusRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    toggleAdminStatusSuccess: (state) => {
      state.loading = false;
    },
    toggleAdminStatusFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchPermissionsRequest: (state) => {
      state.permissionsLoading = true;
      state.permissionsError = null;
    },
    fetchPermissionsSuccess: (state, action) => {
      state.permissionsLoading = false;
      state.permissions = action.payload;
    },
    fetchPermissionsFailure: (state, action) => {
      state.permissionsLoading = false;
      state.permissionsError = action.payload;
    },
    updatePermissionsRequest: (state) => {
      state.loading = true;
      state.error = null;
      state.updateSuccess = false;
    },
    updatePermissionsSuccess: (state) => {
      state.loading = false;
      state.updateSuccess = true;
    },
    updatePermissionsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.updateSuccess = false;
    },
  },
});

export const {
  fetchAdminsRequest,
  fetchAdminsSuccess,
  fetchAdminsFailure,
  createAdminRequest,
  createAdminSuccess,
  createAdminFailure,
  editAdminRequest,
  editAdminSuccess,
  editAdminFailure,
  deleteAdminRequest,
  deleteAdminSuccess,
  deleteAdminFailure,
  toggleAdminStatusRequest,
  toggleAdminStatusSuccess,
  toggleAdminStatusFailure,
  fetchPermissionsRequest,
  fetchPermissionsSuccess,
  fetchPermissionsFailure,
   updatePermissionsRequest,
  updatePermissionsSuccess,
  updatePermissionsFailure,
} = adminSlice.actions;

export default adminSlice.reducer;
